import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class F8964EleService {
  private readonly http = inject(HttpClient);
  private readonly saveParentMeString =
    '99999999999999999999,101100173,101100175,101100156,101100219,101100199,101100222,101100161,101100181,101100174,101100210,101100195,101100208,101100191,101100159,101100155,101100188,101100203,101100165,101100143,101100216,101100162,101100205,101100214,101100193,101100170,101100160,101100158,101100197,101100145,101100220,101100224,101100198,101100154,101100194,101100201,101100192,101100211,101100226,101100212,101100204,101100217,101100151,101100190,101100206,101100163,101100227,101100144,101100169,101100152,101100202,101100150,101100148,101100183,101100171,101100172,101100215,101100209,101100223,101100187,101100196,101100182,101100185,101100140,101100221,101100176,101100218,101100177,101100186,101100141,101100147,101100184,101100164,101100153,101100213,101100200,101100149,101100225,101100179,101100189,101100157,101100146,101100168,101100207,101100142,101100166,101100180';

  loadFormData(
    baseUrl: string,
    options: {
      jcdKey?: any;
      combinationKey?: any;
      taxYear?: string;
      scenario?: string;
      screenKey?: string;
      filterParams?: any;
      globalService?: any;
    } = {}
  ): Observable<any> {
    const globalParams = options.globalService?.globalParams || {};
    const filterParams = options.filterParams || {};

    const params: { [key: string]: string } = {
      action_code: '7rc5om',
      irs_form_no: 'F8964',
      schd_name: 'ELE',
      jcd_key: String(options.jcdKey ?? filterParams.jcd_key ?? globalParams.jcd_key ?? ''),
      combination_key: String(options.combinationKey ?? filterParams.combination_key ?? '')
    };

    const taxYear = options.taxYear ?? filterParams.tax_year ?? globalParams.tax_year;
    const scenario = options.scenario ?? filterParams.scenario ?? globalParams.scenario;
    const screenKey = options.screenKey ?? filterParams.screen_key ?? globalParams.screen_key;

    if (taxYear) {
      params.tax_year = String(taxYear);
    }
    if (scenario !== undefined && scenario !== null && scenario !== '') {
      params.scenario = String(scenario);
    }
    if (screenKey) {
      params.screen_key = String(screenKey);
    }

    const urlParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        urlParams.set(key, params[key]);
      }
    });

    return this.http.get<any>(`${baseUrl}/loadJsonObject?${urlParams.toString()}`, {
      withCredentials: true
    });
  }

  /**
   * Save using Schedule O pattern (action_code 07vrtj):
   * jsonSettings = scheduleSettings[], jsonObj = { addrows, editrows, removerows }
   */
  saveForm(
    baseUrl: string,
    scheduleSettings: any[],
    scheduleDetails: { addrows: any[]; editrows: any[]; removerows: any[] },
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    const globalParams = globalService?.globalParams || {};
    const settings = scheduleSettings?.[0] || {};

    const params: any = {};
    params.tax_year = settings.tax_year ?? rowData.TAX_YEAR;
    params.scenario = settings.scenario ?? rowData.SCENARIO;
    params.jcd_key = settings.jcd_key ?? rowData.JCD_KEY;
    params.parent_me_string = filterParams.parent_me_string
      ?? globalParams.parent_me_string
      ?? rowData.PARENT_ME_STRING
      ?? this.saveParentMeString;
    params.screen_key = filterParams.screen_key ?? globalParams.screen_key;
    params.jcd_ta_key = filterParams.jcd_ta_key ?? globalParams.jcd_ta_key;
    params.activity_key = filterParams.activity_key ?? globalParams.activity_key;
    params.screen_type = filterParams.screen_type ?? globalParams.screen_type ?? 'grid';
    params.is_locked = filterParams.is_locked ?? globalParams.is_locked ?? 'N';

    params.jsonObj = JSON.stringify(scheduleDetails);
    params.jsonSettings = JSON.stringify(scheduleSettings);
    params.scenarioCode = filterParams.scenarioCode
      ?? filterParams.scenario_code
      ?? rowData.SCENARIO_CODE
      ?? globalParams.scenarioCode;
    params.is_issue_key_enabled = 'N';
    params.process_name = 'F8964_ELE_Save';

    const scenarioKey = Number.parseInt(
      String(rowData.SCENARIO_KEY ?? params.scenario ?? ''),
      10
    );
    const checkLockedbj = [{
      leid: rowData.LEID,
      cdr_number: rowData.CDR_NO,
      consol_group_key: rowData.CONSOL_GROUP_KEY,
      reporting_period: rowData.REPORTING_PERIOD,
      combination_key: String(rowData.COMBINATION_KEY ?? ''),
      scenario_key: Number.isNaN(scenarioKey) ? null : scenarioKey
    }];
    params.checkLockedbj = JSON.stringify(checkLockedbj);

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    const url = `${baseUrl}/saveJsonObject?action_code=07vrtj`;

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}
